"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const Toolbar_1 = require("./Toolbar");
const index_1 = require("./Header/index");
const StepsListView_1 = require("./StepsListView");
const hooks_1 = require("../hooks");
const react_if_1 = require("react-if");
const RunConversionView_1 = require("./RunConversionView");
const AppNavBreadcrumbs_1 = require("./AppNavBreadcrumbs");
const Outer_1 = require("../../../panels/ContentImportPanel/Outer");
exports.ConversionCanvasReadyView = () => {
    const { prefs: { view }, state: { showContentImportPanel, sampleContentFeed }, } = hooks_1.useConversionCanvas();
    const { dispatchCanvasAction } = hooks_1.useConversionCanvasUpdate();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysFlexFrame, { osysName: "ConversionCanvasInner.outer", className: "position-relative" },
            react_1.default.createElement(Outer_1.ContentImportPanelOuter, { onContentImport: ({ contentItem }) => {
                    dispatchCanvasAction({
                        data: {
                            sampleContentItem: contentItem,
                            showContentImportPanel: false,
                        },
                        type: 'state',
                    });
                }, contentFeed: sampleContentFeed, onChangeContentFeed: newSampleContentFeed => {
                    dispatchCanvasAction({
                        data: {
                            sampleContentFeed: newSampleContentFeed,
                        },
                        type: 'state',
                    });
                }, isOpen: showContentImportPanel, onClose: () => {
                    dispatchCanvasAction({
                        data: {
                            showContentImportPanel: false,
                        },
                        type: 'state',
                    });
                } }),
            react_1.default.createElement(AppNavBreadcrumbs_1.ConversionCanvasAppNavBreadcrumbs, null),
            react_1.default.createElement(Toolbar_1.ConversionCanvasToolbar, null),
            react_1.default.createElement(react_2.OsmosysFlexFrame.Row, null,
                react_1.default.createElement(react_2.OsmosysFlexFrame.Col, null,
                    react_1.default.createElement(index_1.ConversionCanvasHeader, null),
                    react_1.default.createElement(react_if_1.When, { condition: view === 'runConversion' },
                        react_1.default.createElement(RunConversionView_1.ConversionCanvasRunConversionView, null)),
                    react_1.default.createElement(react_if_1.When, { condition: view === 'stepsList' },
                        react_1.default.createElement(StepsListView_1.ConversionCanvasStepsListView, null)))))));
};
//# sourceMappingURL=index.js.map